
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'

import { Gift } from '@/models'
import { extractApiErrorMessages } from '@/utils/apiErrors'

@Component({
  name: 'ResendGiftEmailDialog'
})
export default class extends Vue {
  @Prop({ required: true }) private visible!: boolean
  @Prop({ required: true }) private gift!: Gift

  private loading = false
  private form = {
    email: ''
  }

  get rules(): any {
    return {
      email: [
        { required: true, message: this.$t('gifts.resendEmailDialog.invalidEmail'), trigger: 'blur' },
        { type: 'email', message: this.$t('gifts.resendEmailDialog.invalidEmail'), trigger: 'blur' }
      ]
    }
  }

  get currentEmail(): string {
    if (this.gift.recipient) {
      return this.gift.recipient.email
    }
    return ''
  }

  get remainingResends(): number {
    const used = this.gift.emailResendCount || 0
    return Gift.MAX_EMAIL_RESENDS - used
  }

  created() {
    this.form.email = this.currentEmail
  }

  private notifyErrors(err: any): void {
    const messages = extractApiErrorMessages(err)
    const fallback = String(this.$t('gifts.resendEmailDialog.notification.error.fallback'))
    const toDisplay = messages.length > 0 ? messages : [fallback]

    for (const message of toDisplay) {
      this.$notify({
        title: String(this.$t('gifts.resendEmailDialog.notification.error.title')),
        message,
        type: 'error',
        duration: 5000
      })
    }
  }

  async submit() {
    const form = this.$refs.form as Form
    const valid = await form.validate().catch(() => false)
    if (!valid) return

    this.loading = true
    try {
      await Gift.resendEmail(this.gift.id, this.form.email.trim())
      this.$notify({
        title: String(this.$t('gifts.resendEmailDialog.notification.success.title')),
        message: String(this.$t('gifts.resendEmailDialog.notification.success.message')),
        type: 'success',
        duration: 2000
      })
      this.$emit('resent')
      this.$emit('close')
    } catch (err: any) {
      this.notifyErrors(err)
    } finally {
      this.loading = false
    }
  }
}
